import React from 'react';
import { Outlet } from 'react-router-dom';
import { ProtectedRoute } from '@routes/ProtectedRoute';
import { Footer } from '@components';
import { PageStyled } from './styled-components';
import { StzBar } from '@core/components/organisms/app-bar';

interface IProtectedLayoutProps {}

const Layout: React.FC<IProtectedLayoutProps> = () => {
    return (
        <>
            <StzBar />
            <PageStyled>
                <Outlet />
            </PageStyled>
            <Footer />
        </>
    );
};

export const ProtectedLayout = () => <ProtectedRoute element={<Layout />} />;
